import { useBooleanState } from '@calendly/hooks';
import { I18n } from '@calendly/i18n';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { IconButton } from '@calendly/ui/components/icon-button';
import { ArrowRoundLeftIcon, ArrowRoundRightIcon, BlockIcon, CloseCircleIcon, EditPencilIcon, SettingsMenuVerticalIcon } from '@calendly/ui/components/icons';
import { BareItem, PopupDropdownMenu } from '@calendly/ui/components/menu';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { BlockModal, UnblockModal, BlockExpiredModal } from 'components/meetings/block_modals';
import { CancelInviteeModal } from './cancel_invitee_modal';
import { ItemContents } from './invitees_widget';
const NINETY_DAYS_MS = 90 * 24 * 60 * 60 * 1000;
const styledMenuCss = "s1kvepni";
const StyledMenu = forwardRef((props, ref) => <PopupDropdownMenu ref={ref} {...props} className={classNames(styledMenuCss, props.className)} />);
export const InviteeActions = ({
  event,
  invitee,
  canReschedule,
  canCancel,
  canBlock,
  canUnblock,
  openEditEmailModal,
  canEditEmail
}) => {
  const [toggleGroupMenu, Dropdown, isExpanded] = useDropdown();
  const [isCancelInviteeModalOpen, openCancelInviteeModal, closeCancelInviteeModal] = useBooleanState(false);
  const [isBlockModalOpen, openBlockModal, closeBlockModal] = useBooleanState(false);
  const [isUnblockModalOpen, openUnblockModal, closeUnblockModal] = useBooleanState(false);
  const [isBlockExpiredModalOpen, openBlockExpiredModal, closeBlockExpiredModal] = useBooleanState(false);
  const isBlocked = invitee.blockedByHost;
  const isOlderThan90Days = invitee.createdAt && Date.now() - new Date(invitee.createdAt).getTime() > NINETY_DAYS_MS;
  const handleBlockClick = () => {
    if (isOlderThan90Days) {
      openBlockExpiredModal();
    } else {
      openBlockModal();
    }
  };
  return <div>
      <IconButton size="small" onClick={toggleGroupMenu} title={I18n.t('publisher.meetings.invitees.invitee_actions')} aria-label={I18n.t('publisher.meetings.invitees.invitee_actions')} aria-expanded={isExpanded}>
        <SettingsMenuVerticalIcon />
      </IconButton>
      <Dropdown>
        <StyledMenu>
          <div>
            {!isBlocked && canReschedule && <BareItem as="a" href={`/reschedulings/${invitee.uuid}?&return_to=${window.location.pathname}`}>
              <ItemContents>
                <ArrowRoundRightIcon spacingRight={4} />
                {I18n.t('publisher.meetings.invitees.reschedule_invitee')}
              </ItemContents>
            </BareItem>}
            {!isBlocked && canEditEmail && <BareItem onClick={openEditEmailModal}>
                <ItemContents>
                  <EditPencilIcon spacingRight={4} />
                  {I18n.t('publisher.meetings.invitees.edit_invitee_email')}
                </ItemContents>
              </BareItem>}
            {!isBlocked && canCancel && <BareItem onClick={openCancelInviteeModal}>
              <ItemContents>
                <CloseCircleIcon spacingRight={4} />
                {I18n.t('publisher.meetings.invitees.remove_invitee')}
              </ItemContents>
            </BareItem>}
            {canBlock && <BareItem onClick={handleBlockClick}>
                <ItemContents>
                  <BlockIcon spacingRight={4} />
                  {event.past ? I18n.t('publisher.block_invitee.action.block_attendee') : I18n.t('publisher.block_invitee.action.block_invitee')}
                </ItemContents>
              </BareItem>}
            {canUnblock && <BareItem onClick={openUnblockModal} disabled={isOlderThan90Days}>
                <ItemContents>
                  <ArrowRoundLeftIcon spacingRight={4} />
                  {event.past ? I18n.t('publisher.block_invitee.action.unblock_attendee') : I18n.t('publisher.block_invitee.action.unblock_invitee')}
                </ItemContents>
              </BareItem>}
          </div>
        </StyledMenu>
      </Dropdown>
      {isCancelInviteeModalOpen && <CancelInviteeModal invitee={invitee} onClose={closeCancelInviteeModal} />}
      {isBlockModalOpen && <BlockModal event={event} invitee={invitee} onClose={closeBlockModal} />}
      {isUnblockModalOpen && <UnblockModal event={event} invitee={invitee} onClose={closeUnblockModal} />}
      {isBlockExpiredModalOpen && <BlockExpiredModal inviteeName={invitee.name} isPast={event.past} onClose={closeBlockExpiredModal} />}
    </div>;
};

require("./invitee_actions.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./invitee_actions.js");